import { withRouter } from "react-router-dom";
import React from "react";
import axios from "axios";
import { withTranslation } from "react-i18next";
import { Row, Col, Skeleton, Card, Statistic, Result } from "antd";
import ChartLineLeads from "./ChartLineLeads";
import ChartRoundLeads from "./ChartRoundLeads";
import "./style.css";
import LatestTasks from "./LatestTasks";
import LatestComments from "./components/LatestComments";

class Dashboard extends React.Component {
  state = {
    leadsGraph: {},
    leadsStatus: {},
    tasksLatest: {},
    commentsLatest: {},
    leadsList: {},
    currentYearTasks: {},
    loading: true,
  };

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };

    this.fetch();
  }

  fetch = (e) => {
    let requestList = [];
    requestList.push(
      axios.get(process.env.REACT_APP_AXIOS_URL + "/api/leads_list_graph/")
    );
    requestList.push(
      axios.get(
        process.env.REACT_APP_AXIOS_URL + "/api/choice_lead_status_list/"
      )
    );
    requestList.push(
      axios.get(
        process.env.REACT_APP_AXIOS_URL + "/api/tasks_latest_dashboard/"
      )
    );
    requestList.push(
      axios.get(
        process.env.REACT_APP_AXIOS_URL + "/api/comments_latest_dashboard/"
      )
    );
    requestList.push(
      axios.get(process.env.REACT_APP_AXIOS_URL + "/api/leads_list/?limit=10")
    );
    requestList.push(
      axios.get(process.env.REACT_APP_AXIOS_URL + "/api/curent_year_tasks/")
    );

    axios
      .all(requestList)
      .then(
        axios.spread((...responses) => {
          const responseGraphLeads = responses[0];
          const responseLeadsStatus = responses[1];
          const responseTasksLatest = responses[2];
          const responseCommentsLatest = responses[3];
          const responseLeadsList = responses[4];
          const responseCurrentYearTasks = responses[5];

          this.setState({
            leadsGraph: responseGraphLeads.data,
            leadsStatus: responseLeadsStatus.data,
            tasksLatest: responseTasksLatest.data,
            commentsLatest: responseCommentsLatest.data,
            leadsList: responseLeadsList.data.results,
            currentYearTasks: responseCurrentYearTasks.data,
            loading: false,
          });
        })
      )
      .catch((errors) => {
        console.log(errors);
      });
  };

  render() {
    const { t, history } = this.props;

    if (this.state.loading) {
      return (
        <div>
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
        </div>
      );
    } else {
      return (
        <div>
          {/* <Row gutter={8}>
                        <Col span={6}>
                            <Card title="Leads" bordered={false}>
                                Total leads
                            </Card>
                            <Statistic title="Leads" value={100} />
                        </Col>
                        <Col span={6}>
                            <Card title="Clients" bordered={false}>
                                Total clients
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card title="Tasks" bordered={false}>
                                Total tasks
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card title="Events" bordered={false}>
                                Card content
                            </Card>
                        </Col>
                    </Row> */}
          <Row gutter={5} style={{ marginTop: 5 }}>
            <Col md={24}>
              {this.state.leadsGraph ? (
                <ChartLineLeads
                  leadsGraph={this.state.leadsGraph}
                  currentYearTasks={this.state.currentYearTasks}
                />
              ) : (
                <Result
                  title={t(
                    "dashboard.view.no_new_leads",
                    "There is no data to display."
                  )}
                />
              )}
            </Col>
          </Row>
          <Row gutter={5} style={{ marginTop: 25 }}>
            <Col md={12}>
              {this.state.commentsLatest ? (
                <React.Fragment>
                  <Card>
                    <p className="pStyle" style={{ textAlign: "center" }}>
                      {t(
                        "dashboard.view.latest_comments",
                        "Latest comments on leads"
                      )}
                    </p>
                    <LatestComments
                      history={history}
                      comments={this.state.commentsLatest}
                    />
                  </Card>
                </React.Fragment>
              ) : (
                <Result
                  title={t(
                    "dashboard.view.no_comments",
                    "There is no comments yet."
                  )}
                />
              )}
            </Col>
            <Col md={12}>
              {this.state.tasksLatest ? (
                <Card>
                  <LatestTasks
                    history={history}
                    tasksLatest={this.state.tasksLatest}
                  />
                </Card>
              ) : (
                <Result
                  title={t("dashboard.view.no_tasks", "There is no tasks yet.")}
                />
              )}
            </Col>
          </Row>
        </div>
      );
    }
  }
}

export default withRouter(withTranslation()(Dashboard));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardView.js